import { Component, Injector, ChangeDetectorRef } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { environment } from '@env/version';
import { environment as env } from '@env/environment';

import { uiHelper } from '~/helpers/ui.helper';
import { CoreService, CustomerUser } from '~/legacy/ts/services/core.service';
import { translationHelper } from '~/helpers/translation.helper';
import { AppComponentBase } from '~/shared/app-component-base';
import { disableBalance } from '@env/environment';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

declare let $;
declare let betaluxBr: any;

@Component({
    selector: 'all-screen-header',
    templateUrl: './AllScreenHeader.html',
})
export class AllScreenHeader extends AppComponentBase {
    public versionT = environment.version;
    public clickCounter = 0;
    public today: number = Date.now();
    public Balance_Text_IsActive = 1;
    public _customerUserData: CustomerUser;
    public disableBalance = disableBalance;
    public openWidget = new Subject();

    liveGoalListData = [];

    constructor(
        public tournamentsService: TournamentsService,
        public _uiHelper: uiHelper,
        public coreService: CoreService,
        public translate: translationHelper,
        private injector: Injector,
        private changeDetectorRef: ChangeDetectorRef,
    ) {
        super(injector);

        this._customerUserData = this.coreService.customerUser;
        this._uiHelper.liveGoalListListener.subscribe((x: any) => {
            this.liveGoalListData = x;
            // console.log('liveGoalListData', x);
            if (x && x != []) {
                this.RunLiveGoalSlide();
            }
        });

        setInterval(() => {
            this.today = Date.now();
        }, 1000);

        this.coreService.customerUserUpdateListener.subscribe(data => {
            console.log(data);
            this._customerUserData = { ...data };
            this.changeDetectorRef.detectChanges();
        });

        if (disableBalance) {
            this.Change_Balance_Text_Status();
        }
        this.openWidget.pipe(throttleTime(3000)).subscribe(i => {
            console.log('openWidget');
            this.openBrSwipeWidget();
        });
    }

    public Open_Payout_Modal() {
        if (this.disableBalance) return;
        this.coreService.configureClient();
        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            $('#PayoutModal')
                .modal({
                    detachable: false,
                })
                .modal('show');
        }
    }

    public Change_Balance_Text_Status() {
        if (this.Balance_Text_IsActive == 0) {
            this.Balance_Text_IsActive = 1;
        } else {
            this.Balance_Text_IsActive = 0;
        }
    }

    public Open_Transaction_Page() {
        this.tournamentsService.cleanOpenBets_Timer();
        this.tournamentsService.customerTransactionDate = '7' + ' ' + this.translate.getT('Day');

        // this.tournamentsService.getCustomerTransaction(-10, 7);
        this.tournamentsService.getCustomerBets('All', 7);
        this.tournamentsService.router.navigate(['/CustomerTransaction']);
    }

    public OpenPasswordModal() {
        setTimeout(() => (this.clickCounter = 0), 3000);

        this.clickCounter += 1;

        if (this.clickCounter == 3) {
            // $('#settingPassword_Modal')
            //    .modal({
            //        allowMultiple: true

            //    }).modal('show');
            // $('#Terminal_Keyboard_Modal')
            //    .modal({
            //        allowMultiple: true
            //    }).modal('show');

            $('#SettingPasswordModalLogin')
                .modal({
                    // allowMultiple: true,
                    detachable: false,
                })
                .modal('show');
            this.clickCounter = 0;
        }
    }
    public Open_Reward_Qr_Modal() {
        let qr: any;
        $('#Qr_Reward_Modal')
            .modal('setting', 'closable', false)
            .modal('show');
        this.tournamentsService.getQrRewardGui().then(x => {
            let parsedData: any;
            parsedData = JSON.parse(JSON.parse(x).Data);
            if (parsedData.status) {
                qr = parsedData.data.qrCode;
                this._uiHelper.SetQrCode(qr);

                // $('#Qr_Reward_Modal')
                //     .modal('setting', 'closable', false)
                //     .modal('show');
            } else {
                qr = '';
                console.error('Something wrong!!!');
            }
        });
    }

    public Open_Info_Modal() {
        $('#Info_Modal').modal('show');
    }

    public handleSportChange(e) {
        this._uiHelper.setSportType(1);
        //this._uiHelper.resetOddType_LIVE();
        // this._uiHelper.resetOddType_PRE();
        this._uiHelper.setTypeOfList(e);
    }

    RunLiveGoalSlide() {
        if (this.liveGoalListData && this.liveGoalListData != []) {
            for (let i = 0; i < this.liveGoalListData.length; i++) {
                setTimeout(() => {
                    if (i != 0) {
                        if (this.liveGoalListData[i - 1] != undefined) this.liveGoalListData[i - 1].visible = false;
                    }
                    if (this.liveGoalListData[i] != undefined) this.liveGoalListData[i].visible = true;
                }, i * 3000);
            }
        }
    }

    public getBalanceButtonBg() {
        // console.log("BAKİYE", this.coreService.customerUser.TerminalBalance);
        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            return '#67b149';
        } else {
            return '#e0e1e2';
        }
    }

    OpenQrModal() {
        const newDate = new Date();

        let qr = '900' + this.coreService.customerUser.TerminalId.toString() + '_' + newDate.getTime().toString();
        this._uiHelper.SetQrCode('b64' + btoa(qr));
        $('#QR_Modal')
            .modal('setting', 'closable', false)
            .modal('show');
    }
    totalidlecounter = 0;
    ExitQrCustomer() {
        //console.log('IDLE-EXIT :' +new Date());
        this._uiHelper.SetCustomerQrStatus(false);
        window.postMessage({ command: 'cardinserted', message: 'removed' }, '*');

        // this._UiHelper.setRefreshApp();
        this.tournamentsService.clearSlip();

        // 30.09.2021 de Kapatıldı
        // LiveBets e Yönlendirme için Kapatıldı. Test edilmesi lazım
        // if (this.coreService.customerUser.IsLogged) {
        //     this.tournamentsService.router.navigate(['/LiveBets']);
        // }
        //this._uiHelper.SendElectronMessage('electronListener', {
        //    type: 'moneyReader_control',
        //    money_reader_status: 'disable',
        //});
        //location.reload();

        //3 DK sonra kimse dokunmazsa burası perfect çalışıyor.

        this.totalidlecounter++;
        if (this.totalidlecounter > 10) {
            this.totalidlecounter = 0;
            location.reload();
        }

        this.tournamentsService.router.navigate(['/LiveBets']);
        this._uiHelper.idleResetListener.emit();
    }

    public Open_Language_Modal() {
        $('#Language_Modal').modal('show');
    }

    // public Qr_Post_Method(qr) {
    //     this.tournamentsService.postQrSave(qr, this._customerUserData.TerminalId).then(result => {
    //         console.warn('result', JSON.parse(result.toString()));
    //     });
    // }

    openBrSwipeWidget() {
        const selectedLang = this.translate.LANGCODE;

        if (typeof betaluxBr !== 'undefined') {
            betaluxBr &&
                betaluxBr.init('betrecommend-swipe', 'widgetContainer', {
                    language: selectedLang,
                    apiKey: env.bRSwipeWidgetApiKey,
                });
            betaluxBr.get('betrecommend-swipe').setLanguage(selectedLang);
            betaluxBr.get('betrecommend-swipe').setNoExternalLink(true);
            betaluxBr.on('betrecommend-swipe', 'addMarketToSlip', events => {
                this.addMarketToSlip(events);
            });
        }
    }

    addMarketToSlip(events) {
        for (let market of events) {
            let newOdd = {
                OddId: parseInt(market.marketId),
                HomeTeam: market.homeTeamName,
                AwayTeam: market.awayTeamName,
                MatchId: market.eventId,
                GroupName: market.marketTypeText + '|',
                OddTypeId: market.marketType,
                OddValue: market.marketValue,
                OutCome: market.marketOutcome,
                SpecialBetValue: market.specialMarketValue,
                EventDate: market.eventDate,
                ShortOddType: market.marketType,
            };
            let newEvent = {
                HomeTeam: market.homeTeamName,
                AwayTeam: market.awayTeamName,
                MatchId: market.eventId,
                EventDate: market.eventDate,
                SportNameOriginal: market.sportName,
                WithBr: true,
            };

            this.tournamentsService.addOddNew(
                newOdd,
                $('input[name="__RequestVerificationToken"]').val(),
                '0',
                newEvent,
                true,
            );
        }

        if (typeof betaluxBr !== 'undefined') {
            betaluxBr.offAll('betrecommend-swipe', 'addMarketToSlip');
        }
    }
}
